module.exports = __webpack_public_path__ + "img/login2.a4749f06.png";